<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Select, Toggle, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';
	import type {
		VirtualComponentConfig,
		VirtualComponentInterface,
		VirtualComponentStatistic,
		VirtualComponentTypes,
	} from 'src/types/VirtualComponents';
	import { bthomeObjectInfos } from 'src/helpers/virtual_helpers/virtual_bthome_helper';

	export let type: VirtualComponentTypes;
	export let settings: VirtualComponentInterface['config'];

	const cloudSettings: VirtualComponentConfig['meta']['cloud'] = settings.meta?.cloud || [];

	const statisticTypes: VirtualComponentStatistic[] = ['measurement', 'accumulation', 'counter'];

	const options: SelectOptionPropsType[] = [
		{
			title: $format('option_none', { default: 'None' }),
			value: null,
		},
		{
			title: $format('option_measurement', { default: 'Measurement' }),
			value: 'measurement',
		},
		{
			title: $format('option_accumulation', { default: 'Accumulation' }),
			value: 'accumulation',
		},
		{
			title: $format('option_counter', { default: 'Counter' }),
			value: 'counter',
		},
	];

	let log = false;
	let statistics: VirtualComponentStatistic = null;

	const update = () => {
		let _cloud: VirtualComponentConfig['meta']['cloud'] = [];
		if (log) _cloud.push('log');
		if (statistics) _cloud.push(statistics);
		if (!settings?.meta) settings.meta = {};
		settings.meta.cloud = _cloud;
	};

	const getCloudStatistics = () => {
		log = cloudSettings.includes('log');
		statisticTypes.forEach((i: VirtualComponentStatistic) => {
			if (cloudSettings.includes(i)) statistics = i;
		});
	};

	const supportBTHomeStatistics =
		bthomeObjectInfos.find((i) => i.id == settings?.obj_id)?.type == 'sensor';
	getCloudStatistics();
</script>

{#if type == 'number' || supportBTHomeStatistics}
	<Text element="h2" class="mb-s">
		{$format('choose_type_of_statistics', {
			default: 'Choose type of statistics',
		})}
	</Text>
{/if}
{#if supportBTHomeStatistics}
	<Toggle
		class="mb-s"
		size="m"
		checked={statistics == 'measurement'}
		on:click={() => {
			statistics = statistics == 'measurement' ? null : 'measurement';
			update();
		}}
		id="toggle-nrmg655"
	>
		{$format('virtual_component_enable_statistics', {
			default: 'Enable Statistics',
		})}
	</Toggle>
{:else if type == 'number'}
	<Select
		aria-label={$format('choose_type_of_statistics', {
			default: 'Choose type of statistics',
		})}
		class="mb-s"
		value={options.find((i) => i.value == statistics) || options[0]}
		size="m"
		icon="fas fa-list"
		{options}
		on:change={(e) => {
			statistics = e.detail['value'];
			update();
		}}
		id="select-jzlzb3i"
	/>
{/if}

<Toggle
	class="mb-s"
	size="m"
	checked={log}
	on:click={() => {
		log = !log;
		update();
	}}
	id="toggle-1vwf2uh"
>
	{$format('virtual_component_enable_event_Log', {
		default: 'Enable Event Log',
	})}
</Toggle>
